'use client';

import { useState } from 'react';

import { Tab, Tabs } from 'lighthouse';

import { InfoTab } from './_components/InfoTab';
import { ProductsTab } from './_components/ProductsTab';
import { ReviewsTab } from './_components/ReviewsTab';
import { VendorTabsProps } from './models';

import { InfoCircle, Message, Shop } from 'iconsax-react';

const VendorTabs = ({ categories, defaultCategoryId, lastPage, offers, storeUuid, vendor, initialCityId }: VendorTabsProps) => {
    const [activeTab, setActiveTab] = useState(1);
    const reviewsCount = vendor?.commentsNumber ? vendor.commentsNumber.toLocaleString('fa-IR') : null;

    return (
        <section
            className='relative mt-3 overflow-hidden rounded-lg border border-solid border-N200 bg-white shadow-elevation1 sm:mt-4
                md:overflow-visible'
            aria-label='بخش‌های فروشگاه'>
            <div className='border-0 border-b border-solid border-N200 px-1 sm:px-3'>
                <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} variant='fullWidth' aria-label='ناوبری فروشگاه'>
                    <Tab
                        value={1}
                        label={
                            <span className='flex items-center gap-1 text-xs sm:gap-1.5 sm:text-sm'>
                                <Shop size={16} color='currentcolor' className='sm:hidden' />
                                <Shop size={18} color='currentcolor' className='hidden sm:block' />
                                محصولات
                            </span>
                        }
                    />
                    <Tab
                        value={2}
                        label={
                            <span className='flex items-center gap-1 text-xs sm:gap-1.5 sm:text-sm'>
                                <InfoCircle size={16} color='currentcolor' className='sm:hidden' />
                                <InfoCircle size={18} color='currentcolor' className='hidden sm:block' />
                                اطلاعات
                            </span>
                        }
                    />
                    <Tab
                        value={3}
                        label={
                            <span className='flex items-center gap-1 text-xs sm:gap-1.5 sm:text-sm'>
                                <Message size={16} color='currentcolor' className='sm:hidden' />
                                <Message size={18} color='currentcolor' className='hidden sm:block' />
                                نظرات{reviewsCount ? ` (${reviewsCount})` : ''}
                            </span>
                        }
                    />
                </Tabs>
            </div>

            <div>
                {activeTab === 1 && (
                    <ProductsTab
                        categories={categories}
                        defaultCategoryId={defaultCategoryId}
                        lastPage={lastPage}
                        offers={offers}
                        storeUuid={storeUuid}
                        initialCityId={initialCityId}
                    />
                )}
                {activeTab === 2 && <InfoTab vendor={vendor} />}
                {activeTab === 3 && <ReviewsTab />}
            </div>
        </section>
    );
};

export default VendorTabs;
